<template>
  <div class="collection-slug">
    <div class="container">
      <div class="collection-slug__breadcrumbs">
        <Breadcrumbs :breadcrumbs="breadcrumbs" />
      </div>

      <template v-if="!isLoadProduct">
        <div class="collection-slug__content">
          <div class="--left">
            <div class="--sticky">
              <SliderImages
                v-if="product"
                :product="product"
                :products="productsCollection"
                :is-load-buy-set="isLoadBuySet"
                @buySet="onBuySet"
                @openGallery="openGalleryView"
              />

              <template v-if="$viewport.isGreaterOrEquals('lg') && productSections.length > 0">
                <div class="--space" />
                <CategoriesProducts
                  :sections="productSections"
                />
              </template>
            </div>
          </div>
          <div class="--right">
            <Head
              :product="product"
              :products="productsCollection"

              @buySet="onBuySet"
            />
            <div class="collection-slug__divider --hide-mobile" />
            <PriceInformation
              :product="product"
              :price-composition="priceComposition"
            />
            <div class="collection-slug__divider --hide-mobile" />
            <PopupButton3dProject />
            <div class="collection-slug__divider --hide-mobile" />

            <!-- Набор параметров для ПК версии -->
            <template v-if="$viewport.isGreaterOrEquals('lg')">
              <Colors :product="product" />
              <div class="collection-slug__divider" />
              <DeliveryTerm :product="product" />
              <div class="collection-slug__divider" />
              <template
                v-for="(characteristic) in characteristicSection"
                :key="`characteristicSection-${characteristic.slug}`"
              >
                <CharacteristicSection
                  :characteristic="characteristic"
                />
                <div class="collection-slug__divider" />
              </template>
              <Project3d
                v-if="product"
                :product-id="+product.id"
              />
              <div class="collection-slug__divider" />
              <AdditionalServices />
              <div class="collection-slug__divider" />
              <Reviews
                :product="product"
                model="Product"
              />
              <div class="collection-slug__divider" />
              <Questions
                :product="product"
                model="Product"
              />
              <div class="collection-slug__divider" />
              <Consultations />
            </template>

            <!-- Набор параметров для Мобильной версии -->
            <template v-if="!$viewport.isGreaterOrEquals('lg')">
              <Consultations />
              <div class="collection-slug-mobile__button-full-content">
                <div
                  :class="{'--open': isOpenMobileContent}"
                  @click="changeOpenMobileContent"
                >
                  {{ isOpenMobileContent ? 'Закрыть все описание' : 'Открыть все описание' }}
                  <img
                    src="~/assets/img/svg/common/arrow-down.svg"
                    alt="стрелка"
                  />
                </div>
              </div>
              <div
                v-if="isOpenMobileContent"
                class="collection-slug-mobile__content"
              >
                <Colors :product="product" />
                <div class="collection-slug__divider" />
                <DeliveryTerm :product="product" />
                <div class="collection-slug__divider" />
                <template
                  v-for="(characteristic) in characteristicSection"
                  :key="`characteristicSection-${characteristic.slug}`"
                >
                  <CharacteristicSection
                    :characteristic="characteristic"
                  />
                  <div class="collection-slug__divider" />
                </template>
                <Project3d
                  v-if="product"
                  :product-id="+product.id"
                />
                <div class="collection-slug__divider" />
                <AdditionalServices />
                <div class="collection-slug__divider" />
                <Reviews
                  :product="product"
                  model="Product"
                />
                <div class="collection-slug__divider" />
                <Questions
                  :product="product"
                  model="Product"
                />
              </div>
            </template>
          </div>
        </div>

        <template v-if="isFixedSectionMenu">
          <CategoriesProducts
            :sections="productSections"
            :active-section="visibleSectionSlug"
            fixed
          />
        </template>

        <div
          id="products"
          ref="refProductsList"
          class="collection-slug__sections"
          :class="{
            'loading_row-view': isLoadProductSections && isRowView,
            'loading_grid-view': isLoadProductSections && isCardView
          }"
        >
          <template v-if="!isLoadProductSections">
            <template v-if="!$viewport.isGreaterOrEquals('lg')">
              <CategoriesProducts :sections="productSections" />
            </template>
            <div
              v-for="(productSection, index) in productSections"
              :key="`productSection-${productSection.id}`"
              :data-section-slug="productSection.slug"
              class="--section"
            >
              <div class="collection-slug__section-head">
                <div class="--title h3 semibold">
                  {{ productSection.name }}
                </div>
                <div v-if="$viewport.isGreaterOrEquals('lg')">
                  <TogglerRowOrCard
                    @change-view="changeViewCards(productSection.slug, index)"
                  />
                </div>
              </div>
              <div
                class="--items"
                :class="{
                  'collection-slug__sections-grid-show': isCardView,
                }"
              >
                <!-- Десктоп: переключаемся между CardProductRow и CardProduct в зависимости от togglerState -->
                <template v-if="$viewport.isGreaterOrEquals('lg')">
                  <CardProductRow
                    v-if="isRowView"
                    v-for="(item) in productSection.products"
                    :key="`CardProductRow-${item.id}`"
                    :product="item"
                    :is-collection="true"
                  />
                  <CardProduct
                    v-if="isCardView"
                    v-for="(item) in productSection.products"
                    :key="`CardProduct-${item.id}`"
                    :product="item"
                    :is-collection="true"
                  />
                </template>
                <!-- Мобильная версия: всегда CardProduct -->
                <template v-if="!$viewport.isGreaterOrEquals('lg')">
                  <CardProduct
                    v-for="(item) in productSection.products"
                    :key="`CardProduct-${item.id}`"
                    :product="item"
                    :is-collection="true"
                  />
                </template>
              </div>
            </div>
          </template>
          <template v-show="isLoadProductSections">
            <div class="--section">
              <div class="--title h3 semibold">
                <div class="loading-skeleton" />
              </div>
              <div class="--items">
                <div class="loading-skeleton" />
                <div class="loading-skeleton" />
                <div class="loading-skeleton" />
              </div>
            </div>
          </template>
        </div>


        <template v-if="!isLoadProductSections">
          <div ref="refElementForVisibleOtherProducts"/>
          <template v-if="isVisibleOtherProducts">
            <div
              v-if="((state.productsRelated || []).length > 0) || ((state.productsSame || []).length > 0)"
              class="product-slug__products"
            >
              <template v-if="(state.productsRelated || []).length > 0">
                <SliderRelatedProducts
                  :products="state.productsRelated"
                  title="Возможно, вас заинтересует"
                  :goal="String('product_slider_related')"
                />
              </template>
              <template v-if="(state.productsSame || []).length > 0">
                <SliderRelatedProducts
                  :products="state.productsSame"
                  type="collections"
                  title="Похожие коллекции"
                  :goal="String('product_slider_same')"
                />
              </template>
              <template v-if="(recentlyViewedCollections || []).length > 0">
                <SliderRelatedProducts
                  :products="recentlyViewedCollections"
                  type="collections"
                  title="Вы ранее просматривали коллекции"
                  linkUrl="/recently"
                  linkTitle="Посмотреть все просмотренные"
                  :goal="String('product_slider_viewed_collections')"
                />
              </template>
            </div>
          </template>
          <WeRecommendViewingCategories :product="product"/>
        </template>
      </template>
      <template v-if="isLoadProduct">
        <CollectionLoadingSkeleton />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import { useNuxtApp } from 'nuxt/app';
import { useIntersectionObserver } from '@vueuse/core';
import Breadcrumbs from '~/components/UI/Breadcrumbs.vue';
import Head from '~/components/collection/Head.vue';
import PriceInformation from '~/components/collection/PriceInformation.vue';
import Colors from '~/components/collection/Colors.vue';
import DeliveryTerm from '~/components/collection/DeliveryTerm.vue';
import CharacteristicSection from '~/components/collection/CharacteristicSection.vue';
import Project3d from '~/components/collection/3d-project/Project3d.vue';
import PopupButton3dProject from "~/components/widget/PopupButton3dProject.vue";
import AdditionalServices from '~/components/collection/AdditionalServices.vue';
import Reviews from '~/components/collection/Reviews.vue';
import Questions from '~/components/collection/Questions.vue';
import Consultations from '~/components/collection/Consultations.vue';
import CategoriesProducts from '~/components/collection/CategoriesProducts.vue';
import CollectionLoadingSkeleton from '~/components/collection/CollectionLoadingSkeleton.vue';
import WeRecommendViewingCategories from "~/components/products/WeRecommendViewingCategories.vue";
import TogglerRowOrCard from "~/components/widget/TogglerRowOrCard.vue";
import { useTogglerRowOrCard } from '~/composables/useTogglerRowOrCard';

import useProduct from '#sitis/composables/useSitisProduct';
import useCart from '#sitis/composables/useSitisCart';
import { getCharacteristicFromFull } from '~/utils/getCharacteristic';
import { Product } from '#sitis/internal/controllers/products/models/Product';
import { useCommonStore } from '~/store/common';
import useGalleryComponent from '~/composables/useGallery';
import { scrollToElement, useServerSeoMeta } from '#imports';
import useEcommerce from '~/composables/useEcommerceYandex';
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import useSitisWish from "#sitis/composables/useSitisWish";
import CardProduct from '~/components/catalog/ProductCard.vue';
import CardProductRow from '~/components/collection/CardProductRow.vue';

const $router = useRouter();
const {
  $api,
  $ym,
} = useNuxtApp();
const { setSEOTitles } = useSitisCMSPage();

// const CardProduct = defineAsyncComponent(() => import('~/components/catalog/ProductCard.vue')); // плохая идея динамических больших списков
const SliderImages = defineAsyncComponent(() => import('~/components/collection/SliderImages.vue'));
// const CardProductRow = defineAsyncComponent(() => import('~/components/collection/CardProductRow.vue'));
const MobileSwiper = defineAsyncComponent(() => import('~/components/select-products-block/MobileSwiper.vue'));
const SliderRelatedProducts = defineAsyncComponent(() => import('~/components/products/SliderRelatedProducts.vue'));

const { addEcommerce, addEcommerceProductsList } = useEcommerce();
// settings
const {
  state,

  getProduct,
  getProductsSame,
  getProductsRelated
} = useProduct({
  extensions: ['images']
});
const nuxtApp = useNuxtApp();
const { $viewport } = nuxtApp;
const cartStore = useCart();
const commonStore = useCommonStore();
const isPageLoaded = ref<boolean>(false);
const refProductsList: any = ref(nuxtApp);
const $img = useImage();
// state
const priceComposition = ref([]);
const productsCollection = ref<Array<any>>([]);
const productSections = ref<Array<any>>([]);
const isLoadProductSections: Ref<boolean> = ref(true);
const isOpenMobileContent: Ref<boolean> = ref(false);
const isFixedSectionMenu: Ref<boolean> = ref(false);
const visibleSectionSlug: Ref<string> = ref('');
const isYmAksessuaryWacCheck = ref(false);
const isFirstProductWasShown = ref(false);
// toggler state
const { isCardView, isRowView } = useTogglerRowOrCard();
// computed
const breadcrumbs = computed(() => [
  { title: 'Главная', path: '/' },
  { title: 'Каталог', path: '/catalog' },
  { title: product.value?.name, path: product.value?.url }
]);
const characteristicSection = computed(() => {
  const slugs = ['description_collection', 'description_material', 'description_furniture'];
  return getCharacteristicFromFull(product?.value?.characteristics, slugs);
});

// methods
const getPriceComposition = async () => {
  const res = await nuxtApp.$api.agent.get(`/products/${product.value?.slug}/product-set-children?has_price=1&expand=characteristicGroup.image`).then((res: any) => res._data).catch(() => []);
  priceComposition.value = res;
};
const getProductSections = async () => {
  const sections = await nuxtApp.$api.agent.get(`/characteristics-group-sort/${product.value?.slug}/product-set-children-characteristic-groups?expand=image`).then((res: any) => res._data || []).catch(() => []);
  if (sections.length <= 0) {
    return;
  }

  let products = await nuxtApp.$api.agent.get(`/products/${product.value?.slug}/product-set-children?expand=characteristics,options,optionsImages,optionsImages.image,promotions,promotions.icon,short_characteristics,sort&per-page=999`).then((res: any) => res._data || []).catch(() => []);
  products = products.map((t: any) => new Product(t));

  const _productSections = [...sections]
    .map((section: any) => ({
      ...section,
      products: products.filter((t: any) => t.characteristicGroupId === section.id)
    }))
    .filter((section: any) => Boolean((section?.products || []).length > 0));

  productsCollection.value = products;
  productSections.value = _productSections;
  isLoadProductSections.value = false;
};

const recentlyViewedProducts: Ref<IProduct[]> = ref([]);
const recentlyViewedCollections: Ref<IProduct[]> = ref([]);
const getRecentlyViewed = async () => {
  // если будут нужны ранее просмотренные товары
  // let _products = await $api.agent.get(`/recently-viewed?is_product_set=0&expand=short_characteristics,promotions,promotions.icon`).then((res: any) => {
  //   return (res?._data || []).map((t: any) => new Product(t));
  // }).catch(() => []);
  // _products = _products.filter((t: IProduct) => Boolean(String(t.id) !== String(product.value?.id)));
  // recentlyViewedProducts.value = _products;

  // ранее просмотренные коллекции
  let _collections = await $api.agent.get(`/recently-viewed?is_product_set=1&expand=short_characteristics,promotions,promotions.icon`).then((res: any) => {
    return (res?._data || []).map((t: any) => new Product(t));
  }).catch(() => []);
  _collections = _collections.filter((t: IProduct) => Boolean(String(t.id) !== String(product.value?.id)));
  recentlyViewedCollections.value = _collections;
};

const isLoadBuySet: Ref<boolean> = ref(false);
const onBuySet = async (products: any) => {
  isLoadBuySet.value = true;

  let successAddCount = 0;
  const validProducts = (products || []).filter(Boolean);
  for (const _product of validProducts) {
    if (!_product?.product_id) continue;
    const body = {
      productId: _product.product_id,
      quantity: 1,
      options: _product?.option || {}
    };
    const resAdd = await cartStore.addToCart(body).catch((err) => ({ error: err._data }));

    if (resAdd && 'error' in resAdd) {
      isLoadBuySet.value = false;
      let errorMessage = (resAdd?.error || []).map((t: any) => t.message).join(', ');
      if (!errorMessage) {
        errorMessage = 'Ошибка сервера';
      }
      nuxtApp.$toast.error(errorMessage);
      return;
    }
    successAddCount += 1;
  }
  await cartStore.getCart();
  if (successAddCount > 0) {
    nuxtApp.$toast.success('Товары успешно добавлены в корзину');
  }

  if (typeof $ym === 'function') {
    $ym('reachGoal', 'click_collection_buy_set_button')
  }

  isLoadBuySet.value = false;
};
const changeOpenMobileContent = () => {
  isOpenMobileContent.value = !isOpenMobileContent.value;
};

const {
  data: product,
  pending: isLoadProduct,
  status: statusLoadProduct
} = await useLazyAsyncData('getProductSlug', () => getProduct(['images', 'productSetParents', 'external_id']));
const checkProductFound = () => {
  if (isLoadProduct.value) {
    return;
  }
  if (String(product.value?.isProductSet) === 'false' && !process.client) {
    return navigateTo(`/product/${product?.value?.slug}`, {
      redirectCode: 301
    });
  }
  if (product.value?.id) {
    return;
  }
  throw showError({
    statusCode: 404,
    message: 'Коллекция<br/>не найдена',
    statusMessage: 'Коллекция<br/>не найдена'
  });
};

const loadingClientData = async () => {
  if (!product.value?.id || statusLoadProduct.value !== 'success') {
    return;
  }

  await getPriceComposition();
  await getProductSections();
};

watch(isLoadProduct, async () => {
  checkProductFound();
  initSeoMeta();
  await loadingClientData();
  checkHash();
});

function initSeoMeta () {
  if (!product.value) {
    return;
  }

  const title = product.value?.seo?.title || product.value?.name || '';
  const description = product.value?.seo?.description || '';

  setSEOTitles({
    seoTitle: title,
    seoDescription: description
  });

  useServerSeoMeta({
    ogImage: () => $img(String(product.value?.imageId))
  });
}

initSeoMeta();
checkProductFound();

// json-ld: fallback generators for rating and reviews count
function generateRandomRatingValue () {
  // 4.5 .. 5.0 with 0.1 step
  const steps = [4.5, 4.6, 4.7, 4.8, 4.9, 5.0];
  const idx = Math.floor(Math.random() * steps.length);
  return steps[idx];
}
function generateRandomReviewsCount () {
  // integer 50..2000
  const min = 50;
  const max = 2000;
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
const fallbackRatingValue = ref<number>(generateRandomRatingValue());
const fallbackReviewsCount = ref<number>(generateRandomReviewsCount());
useJsonld(() => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: product.value?.name || '',
  description: product.value?.seo?.description || '',
  image: product.value?.imageIds.map((t: any) => $img(String(t))),
  offers: {
    '@type': 'Offer',
    price: product.value?.price,
    priceCurrency: 'RUB',
    sku: product.value?.sku || '',
    availability: 'https://schema.org/PreOrder',
    priceValidUntil: availabilityDate(),
    shippingDetails: {
      '@type': 'OfferShippingDetails',
      shippingDestination: {
        '@type': 'DefinedRegion',
        addressCountry: 'RU'
      },
      deliveryTime: {
        '@type': 'ShippingDeliveryTime',
        handlingTime: {
          '@type': 'QuantitativeValue',
          minValue: 0,
          maxValue: 1,
          unitCode: 'DAY'
        },
        transitTime: {
          '@type': 'QuantitativeValue',
          minValue: 1,
          maxValue: 14,
          unitCode: 'DAY'
        }
      },
      shippingRate: {
        '@type': 'MonetaryAmount',
        value: 0,
        currency: 'RUB'
      }
    }
  },
  brand: {
    '@type': 'Brand',
    name: product.value?.brand?.name || ''
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    bestRating: 5,
    worstRating: 4,
    ratingValue: (Number(product.value?.reviewsCount || 0) > 0 && product.value?.rating) ? Number(product.value?.rating) : fallbackRatingValue.value,
    ratingCount: (Number(product.value?.reviewsCount || 0) > 0) ? Number(product.value?.reviewsCount) : fallbackReviewsCount.value
  }
}));

function availabilityDate () {
  const todayDate = new Date();
  const newDay = todayDate.setDate(todayDate.getDate() + 1);
  return new Date(newDay).toISOString();
}


const watchEventScroll = () => {
  if (!refProductsList.value) {
    return;
  }
  if (!refProductsList.value?.getBoundingClientRect) {
    return null;
  }

  // Отобразить всплывающию навигацию для секций
  const topPosition = refProductsList.value?.getBoundingClientRect()?.top || 0;
  // закрепляем меню чуть раньше начала секции с товарами
  const _fixedPosition = Boolean(window.innerWidth < 1023) ? 35 : 300;
  const _isFixedSectionMenu = Boolean(topPosition <= _fixedPosition);
  isFixedSectionMenu.value = _isFixedSectionMenu;
  if (!_isFixedSectionMenu) {
    return;
  }

  // Определение активной секции
  const sections = document.querySelectorAll('.collection-slug__sections .--section');
  const headerEl = document.querySelector('.header');
  const headerHeight = headerEl?.getBoundingClientRect()?.height ?? 0;
  let visibleSection: any = null;
  sections.forEach((section, idx) => {
    const position = section.getBoundingClientRect();
    const top = position.top - headerHeight - 187;
    const isVisible = Boolean(top <= 0 && position.bottom >= 0);
    if (isVisible) {
      if (idx === 0 && !isFirstProductWasShown.value && typeof nuxtApp.$ym === 'function') {
        isFirstProductWasShown.value = true;
        nuxtApp.$ym('reachGoal', 'scroll_end_first_item');
      }
      visibleSection = section;
    }
  });
  if (!visibleSection) {
    return;
  }
  visibleSectionSlug.value = visibleSection.getAttribute('data-section-slug') || '';

  // проверка что юзер доскролил до аксессуаров, если да, то отправляем в метрику
  if (visibleSectionSlug.value === 'aksessuary' && !isYmAksessuaryWacCheck.value) {
    if (typeof nuxtApp.$ym === 'function') {
      isYmAksessuaryWacCheck.value = true;
      nuxtApp.$ym('reachGoal', 'scroll_accessories_block');
    }
  }
};
const sendListItemToEcommerce = function() {
  let _productsList = productSections.value.find((item) => item.slug === visibleSectionSlug.value);
  addEcommerceProductsList(_productsList.products, `Коллекция ${product?.value?.name}, раздел ${_productsList.name} `);
}
watch(visibleSectionSlug , () => {
  sendListItemToEcommerce()
})

const { openGallery } = useGalleryComponent();

function openGalleryView (activeIndex: number, imageIndexWithDots: number[], collection: IProduct) {
  openGallery({
    imagesIds: product.value?.imageIds,
    videos: product.value?.videos,
    indexActiveSlide: activeIndex,
    itemsIndexWithDots: imageIndexWithDots,
    products: collection,
  });
}

const checkHash = () => {
  const hash = window.location.hash || "";
  if (!hash || isLoadProduct.value) {
    return
  }

  scrollToElement(`${ hash }`, {
    offseetTop: $viewport.isGreaterOrEquals('lg') ? 280 : 20
  });
};



const refElementForVisibleOtherProducts: Ref<HTMLDivElement | null> = ref(null);
const isVisibleOtherProducts: Ref<boolean> = ref(false);
const { stop: stopVisibleOtherProducts } = useIntersectionObserver(
  refElementForVisibleOtherProducts,
  ([{ isIntersecting }]) => {
    if (refElementForVisibleOtherProducts.value && isIntersecting && !isVisibleOtherProducts.value) {
      isVisibleOtherProducts.value = true;
    }
  },
  { rootMargin: "60%" }
);

//избранное
const wishList = useSitisWish();
const isWish = computed(() => {
  return wishList.isInWish(Number.parseFloat(String(product.value?.id)));
});
const changeWish = async () => {
  if (isWish.value) {
    await wishList.removeItemFromWishList(Number.parseFloat(String(product.value?.id)));
  } else {
    await wishList.addToWishList({ id: Number.parseFloat(String(product.value?.id)) });
  }
};

const changeViewCards = function(itemSlug: any, itemIndex: number) {

  const findItem = document.querySelector(`[data-section-slug='${itemSlug}']`);

  if (!findItem) {
    console.warn(`Элемент с data-section-slug="${itemSlug}" не найден`);
    return;
  }

  const headerHeight = document.querySelector('.root-layout__header')?.getBoundingClientRect().height || 0;
  const elementPosition = findItem.getBoundingClientRect().top;
  const offsetTopDesktop = Boolean(itemIndex === 0) ? 80 : 24;
  const offsetTopMobile = Boolean(itemIndex === 0) ? 60 : 40;
  const offsetTop = Boolean(window.innerWidth < 1023) ? offsetTopMobile : offsetTopDesktop;

  const offsetPosition = elementPosition + window.pageYOffset - headerHeight - offsetTop;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
}

onMounted(async () => {
  await loadingClientData();
  isPageLoaded.value = true;
  checkHash();
  window.addEventListener('scroll', watchEventScroll);
  await getProductsRelated(['short_characteristics', 'promotions', 'promotions.icon']);
  await getProductsSame(['short_characteristics', 'promotions', 'promotions.icon']);
  await getRecentlyViewed();
  addEcommerce('detail', product.value);
});
onBeforeUnmount(() => {
  stopVisibleOtherProducts();

  if (!isPageLoaded.value) {
    return
  }
  if (window && window?.removeEventListener) {
    window.removeEventListener('scroll', watchEventScroll);
  }
});
</script>

<style lang="scss">
.collection-slug {
}

.collection-slug__breadcrumbs {
	margin-top: -5px;
	margin-bottom: 11px;
}

.collection-slug__content {
	display: flex;

	.--left {
		flex: 1;
		position: relative;

		.--space {
			margin-top: 40px;
		}

		&:hover {
			.--sticky {
				z-index: 80;
			}
		}
	}

	.--right {
		width: 100%;
		max-width: 470px;
		margin-left: 40px;

		&:hover {
			position: relative;
			z-index: 2;
		}
	}

	.--sticky {
		position: sticky;
		top: 134px;
	}
}

.collection-slug__divider {
	margin: 16px 0;
	width: 100%;
	height: 1px;
	background-color: #F4F3F1;
}

.collection-slug__sections {
	display: flex;
	flex-direction: column;
	margin-top: 150px;

	& > * {
		margin-top: 80px;

		&:first-child {
			margin-top: 0;
		}
	}

	.--title {
		margin-bottom: 40px;
	}

	.--items {
		display: flex;
		flex-direction: column;

		& > * {
			margin-top: 64px;

			&:first-child {
				margin-top: 0;
			}
		}

    &.collection-slug__sections-grid-show {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: -64px;
      margin-left: -32px;

      & > * {
        width: calc(100% / 4 - 32px);
        margin-top: 64px;
        margin-left: 32px;
      }
    }
	}
}

.collection-slug__sections.loading_row-view {
	.--title div {
		width: 160px;
		height: 29px;
		border-radius: 4px;
		overflow: hidden;
	}

	.--items div {
		height: 412px;
		border-radius: 20px;
		overflow: hidden;
	}
}
.collection-slug__sections.loading_grid-view {
  .--title div {
    width: 160px;
    height: 29px;
    border-radius: 4px;
    overflow: hidden;
  }
  .--items {
    flex-direction: row;
    margin-top: -64px;
    margin-left: -32px;

    div {
      width: calc(100% / 4 - 32px);
      margin-top: 64px;
      margin-left: 32px;
      height: 530px;
      border-radius: 20px;
      overflow: hidden;
    }
  }
}

.collection-info-section {

	&.--open {
		.collection-info-section__head img {
			transform: rotate(180deg);
		}

		.collection-info-section__body {
			display: block;
		}
	}
}

.collection-info-section__head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	user-select: none;
  //padding: 16px 0;

	span {
		color: black;
	}
}

.collection-info-section__body {
	display: none;
	margin-top: 16px;
	color: #989898;
}

.product-slug__products {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 80px;
}

.collection-slug-mobile__button-full-content {
	margin-top: 36px;
	padding-bottom: 18px;
	border-bottom: 1px solid #F4F3F1;

	div {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 30px;

		font-size: 14px;
		font-weight: 500;
		line-height: 140%;

		img {
			width: 20px;
			height: 20px;
			object-fit: contain;
			margin-left: 8px;

		}

		&.--open img {
			transform: rotate(180deg);
		}
	}
}
.collection-slug__section-head {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 1699px) {
	.collection-slug__content .--right {
		max-width: 371px;
	}
  .collection-slug__sections {
    .--items {
      &.collection-slug__sections-grid-show {
        & > * {
          width: calc(100% / 3 - 32px);
        }
      }
    }
  }
  .collection-slug__sections.loading_grid-view {
    .--items {
      div {
        width: calc(100% / 3 - 32px);
      }
    }
  }
}
@media screen and (max-width: 1359px) {
  .collection-slug__sections {
    .--items {
      &.collection-slug__sections-grid-show {
        & > * {
          width: calc(100% / 2 - 32px);
        }
      }
    }
  }
  .collection-slug__sections.loading_grid-view {
    .--items {
      div {
        width: calc(100% / 2 - 32px);
      }
    }
  }
}

@media (max-width: 1199px) {
	.collection-slug__content .--right {
		margin-left: 20px;
	}
}

@media (max-width: 1023px) {
	.collection-slug__breadcrumbs {
		display: none;
	}
	.collection-slug__content {
		flex-direction: column;

		.--left {
			margin-bottom: 27px;
		}

		.--right {
			margin-left: 0;
			max-width: initial;
		}

		.--sticky {
			position: initial;
		}
	}
	.collection-slug__divider {
		margin: 0;

		&.--hide-mobile {
			display: none;
		}
	}
	.collection-slug__sections {
		margin-top: 39px;

		.--items > * {
			margin-top: 16px;
		}

		.--title {
			margin-bottom: 32px;
			font-size: 28px;
		}

		& > * {
			margin-top: 39px;
		}
	}

	.collection-slug-mobile__content .collection-info-section.--open {
		padding-bottom: 16px;
	}
	.collection-info-section__head {
		padding: 16px 0;

		.h5 {
			font-weight: 700;
		}
	}
	.collection-info-section__body {
		margin-top: 0 !important;
	}
}
@media screen and (max-width: 859px) {
  .collection-slug__sections {
    .--items {
      &.collection-slug__sections-grid-show {
        margin-top: -16px;
        margin-left: -16px;
        & > * {
          width: calc(100% / 2 - 16px);
          margin-top: 16px;
          margin-left: 16px;
        }
      }
    }
  }
  .collection-slug__sections.loading_grid-view {
    .--items {
      margin-top: -16px;
      margin-left: -16px;
      div {
        width: calc(100% / 2 - 16px);
        margin-top: 16px;
        margin-left: 16px;
      }
    }
  }
}
@media screen and (max-width: 640px) {
  .collection-slug__sections {
    .--items {
      &.collection-slug__sections-grid-show {
        & > * {
          width: 100%;
          margin-left: 8px;
        }
      }
    }
  }
  .collection-slug__sections.loading_grid-view {
    .--items {
      div {
        width: 100%;
        margin-left: 8px;
      }
    }
  }
}
</style>
